import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { _serverUrl2 } from "../../../config";
import { failed } from "../../../Utils/Alerts";
import { getCookie, setCookie } from "../../../Utils/Cookies";
import DataTableTool from "../../../Utils/DataTableTool";

export default function Calisma() {
  const history = useHistory();
  const cookieDate = getCookie("_d") || new Date().toISOString().split("T")[0];
  const [bitisTrh, setBitisTrh] = useState(cookieDate);
  const [detay, setDetay] = useState([]);
  const [kisi, setKisi] = useState([]);
  const [sayfa, setSayfa] = useState();

  const fetchData = async (url, params = {}, setter) => {
    try {
      const res = await axios.post(url, params);
      setter(res.data.rows);
    } catch {
      failed("Veriler Getirilirken Hata Oluştu");
    }
  };

  const fetchInfo = useCallback(async () => {
    let tempInfo = {
      numarataj_7gunluk: [],
      direkduvar_7gunluk: [],
    };

    await fetchData(_serverUrl2 + "/statics/calismaDetayBilgileri", { bitisTarihi: bitisTrh }, setDetay);
    await fetchData(_serverUrl2 + "/statics/calismaDuzenlemeYapan", { bitisTarihi: bitisTrh }, setKisi);

    try {
      const numaratajRes = await axios.get(_serverUrl2 + "/statics/hsignStatusByDate", { params: { bitisTarihi: bitisTrh } });
      if (numaratajRes.data.status) {
        tempInfo.numarataj_7gunluk = numaratajRes.data.rows;
      } else {
        failed("Veriler Getirilirken Hata Oluştu. " + numaratajRes.data.error);
      }
    } catch (err) {
      failed("Veriler Getirilirken Hata Oluştu. " + err);
    }

    try {
      const direkduvarRes = await axios.get(_serverUrl2 + "/statics/signStatusByDate");
      if (direkduvarRes.data.status) {
        tempInfo.direkduvar_7gunluk = direkduvarRes.data.rows;
      } else {
        failed("Veriler Getirilirken Hata Oluştu. " + direkduvarRes.data.error);
      }
    } catch (err) {
      failed("Veriler Getirilirken Hata Oluştu. " + err);
    }
  }, [bitisTrh]);

  const handlePageChange = (event) => {
    const value = event.target.value;
    if (value === "Personel Çalışmaları") {
      setSayfa(value);
      history.push("/dashboard/calisma");
    } else {
      setSayfa(value);
      history.push("/dashboard/statics");
    }
  };

  useEffect(() => {
    fetchInfo();
  }, [bitisTrh, fetchInfo]);

  return (
    <div className="row">
      <div className="col-6">
        <div className="textBox">
          <div className="header">Tarih Seçimi</div>
          <div className="content d-flex d-inline">
            <input
              type="date"
              onChange={(e) => {
                setCookie("_d", e.target.value, 1);
                setBitisTrh(e.target.value);
              }}
              value={bitisTrh}
              className="form-control"
            />
          </div>
        </div>
      </div>

      <div className="col-6">
        <div className="textBox">
          <div className="header">Konu</div>
          <div className="content">
            <select className="form-control form-select" value={sayfa} onChange={handlePageChange}>
              <option>Numarataj ve Direk/Duvar</option>
              <option>Personel Çalışmaları</option>
            </select>
          </div>
        </div>
      </div>

      <div className="col-sm-6">
        <div className="textBox">
          <div className="header mb-0">Çalışma Türleri</div>
          <div className="content">
            <DataTableTool
              routeObject={{
                title: "Çalışma Türlerine Göre",
                api: "/statics/calismaDetayBilgileri/Table",
                filter: { bitisTarihi: bitisTrh },
                type: "calisma",
              }}
              label={detay.map((d) => d.tip)}
              data={detay.map((d) => d.count)}
              allData={detay.map((d) => ({ label: d.tip, val: d.count }))}
            />
          </div>
        </div>
      </div>

      <div className="col-sm-6">
        <div className="textBox">
          <div className="header mb-0">Personel Çalışmaları</div>
          <div className="content">
            <DataTableTool
              label={kisi.map((d) => (
                <Link to={{ pathname: `/dashboard/kullaniciDetay/${d.kullanici_adi}`, search: `?tarih=${bitisTrh}` }}>{d.kullanici_adi}</Link>
              ))}
              data={kisi.map((d) => d.count)}
              allData={kisi.map((d) => ({ label: d.kullanici_adi, val: d.count }))}
            />
          </div>
        </div>
      </div>

      <div className="col-sm-12" style={{ flexDirection: "column-reverse", minWidth: "200px", flexWrap: "wrap", display: "flex", flexGrow: 2 }}>
        <div className="textBox" style={{ width: "100%" }}>
          <div className="header mb-0">İşlem Sayıları</div>
          <div className="content">
            <DataTableTool
              showChart={false}
              allData={detay.map((d) => ({ label: d.tip, val: d.count }))}
              label={detay.map((d) => {
                switch (d.tip) {
                  case 6:
                    return "Numarataj Kurum Kontrol";
                  case "5":
                    return "Direk/Duvar Kurum Kontrol";
                  case 4:
                    return "Tabela";
                  case "3":
                    return "Direk/Duvar";
                  default:
                    return "Numarataj";
                }
              })}
              data={detay.map((d) => d.count)}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
